//ecd:228317901H20261022084009_V3.0
/**
 * UserRole
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
export const UserRole = {
    USER: "U",
    ADMIN: "A"
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];


/** The constant a wire value stands for, or undefined. */
export function userRoleOf(value: string | null | undefined): UserRole | undefined{
    if (value == null) return undefined;
    return Object.values(UserRole).find((v) => v === value) as UserRole | undefined;
}

/** What a screen shows for each value. */
export const UserRoleLabel: Record<UserRole, string> = {
    [UserRole.USER]: "User",
    [UserRole.ADMIN]: "Administrator",
};
